import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetProtocol(id: string | undefined) {
  return useQuery(queries.protocols.getProtocolById(id || ''))
}
